<template>
  <header :class="`header ${position}`">
    <router-link to="/">
      <img class="header__logo" src="../../assets/img/logo.png" alt="Logo Bralife" aria-label="Link de volta para a home" />
    </router-link>
    <a href class="header__simulation-link" @click.prevent="goToSimulation">Faça uma simulação</a>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      position: ""
    };
  },
  methods: {
    stickingHeader: function() {
      let lastScroll = scrollY;
      window.addEventListener("scroll", () => {
        if (scrollY < lastScroll) {
          this.position = "sticky";
        } else if (scrollY > 0) {
          this.position = "scrolling";
        } else {
          this.position = "";
        }
        lastScroll = scrollY;
      });
    },
    goToSimulation: function() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
        setTimeout(() => {
          const forms = document.querySelector(".home__area--forms");
          scrollTo(0, forms.offsetTop - this.$el.offsetHeight);
        }, 300);
      } else {
        const forms = document.querySelector(".home__area--forms");
        scrollTo(0, forms.offsetTop - this.$el.offsetHeight);
      }
    }
  },
  mounted() {
    this.stickingHeader();

    window.addEventListener("resize", () => {
      const SELF = this;
      setTimeout(function() {
        SELF.stickingHeader();
      }, 500);
    });
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: $space__xs $space__sm 0 $space__sm;
  justify-content: space-between;
  align-items: center;
  background: $color__white;
  box-shadow: $shadow__header;
  z-index: 4;

  @include breakpoint($desk__min--sm) {
    padding: $space__sm;
  }

  &.sticky,
  &.scrolling {
    animation-timing-function: ease-in-out;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }

  &.sticky {
    animation-name: headerApearing;
  }

  &.scrolling {
    animation-name: headerhiding;
  }

  a {
    display: block;
  }

  &__logo {
    display: block;
    max-width: 150px;

    @include breakpoint($desk__min--sm) {
      max-width: 200px;
    }
  }
  &__simulation-link {
    font-family: $font-family__secodary;
    color: $color__secondary;

    &:visited {
      color: $color__secondary;
    }

    @include breakpoint($mobile__max--lg) {
      font-size: $font-size__md;
      max-width: 8ch;
    }
  }
}
</style>
